export default {
  namespaced: true,
  alarms_commands: {
    title: "Alarms commands",
    add_alarm_command: 'Add alarm command',
    edit_alarm_command: 'Edit alarm command',
  },
};
